import { FeedbackService } from "@/clients/services/FeedbackService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetFeedback = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.FEEDBACK],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await FeedbackService.getFeedbackApiV1FeedbackGet(
        user.id,
      );
      return data;
    },
  });
  return {
    feedback: data,
    isLoading,
    error,
  };
};
